<template>
  <div>
    <v-list-tile>
      <v-list-tile-avatar>
        <v-icon>person</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title v-html="location.name"></v-list-tile-title>
        <v-list-tile-sub-title v-html="location.category"></v-list-tile-sub-title>
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>chat_bubble</v-icon>
      </v-list-tile-action>
    </v-list-tile>

              <!-- <v-divider inset></v-divider> -->
    <!-- <li><router-link to=:link >{{location.full_name }} - {{location.last_name}}</router-link></li> -->
  </div>
</template>

<script>
export default {
  props: ['location'],
  computed: {
    full_name () {
      return this.location.first_name + ' ' + this.location.last_name
    },
    link: function () {
      return `/locations/edit/${this.location.id}`
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/locations/Location.vue